module.exports = __webpack_public_path__ + "static/media/reject-refund@3x.5b8cef2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/refund/reject-refund@3x.png
// module id = 2015
// module chunks = 6